import * as React from "react";

function Filter(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 19 18" fill="none" {...props}>
      <path
        d="M18.5 0v2h-1l-5 7.5V18h-6V9.5L1.5 2h-1V0h18zM3.904 2L8.5 8.894V16h2V8.894L15.096 2H3.904z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoFilter = React.memo(Filter);
export default MemoFilter;
